// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"31bf9d75","455":"de1baaba","977":"30a39101"}[chunkId] + ".chunk.js";
};